import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface TaskDependency {
  id: string;
  blocked_by_task_id: string;
  blocked_by_task: {
    id: string;
    title: string;
    status: string;
  } | null;
}

export function useTaskDependencies(taskId: string, enabled: boolean) {
  const { data: dependencies = [], isLoading } = useQuery({
    queryKey: ['task-dependencies', taskId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('task_dependencies')
        .select('id, blocked_by_task_id, blocked_by_task:tasks!task_dependencies_blocked_by_task_id_fkey(id, title, status)')
        .eq('task_id', taskId);

      if (error) throw error;
      return (data || []) as unknown as TaskDependency[];
    },
    enabled: !!taskId && enabled,
  });

  const hasActiveDependencies = dependencies.some(
    d => d.blocked_by_task && d.blocked_by_task.status !== 'completed'
  );

  return { dependencies, hasActiveDependencies, isLoading };
}
